import React from 'react'
import './balanced.scss';
const Balanced = () => {
    return (
        <>
            <section className='balanced_main' id='portfolio'>
                <div className='innner_abstract'>
                    <div className='custom-container'>
                        <div>
                            <h2>Portfolio Strategy</h2>
                            <h3>Balanced for Growth & Resilience</h3>
                            <div className='outer_div'>
                                <div className='cardinner_one'>

                                    <h4>TIER 1</h4>
                                    <h5>Backbone (40%)</h5>
                                    <p>Mega-cap leaders providing stability.</p>
                                    <img src='\assets\onecoin.svg' className='imgonne' />
                                </div>
                                <div className='cardinner_two'>

                                    <h4>TIER 2</h4>
                                    <h5>Growth Engines (30%)</h5>
                                    <p>Rising stars with strong momentum.</p>
                                     <img src='\assets\twocoin.svg'className='imgonne' />
                                </div>
                                <div className='cardinner_three'>

                                    <h4>TIER 3</h4>
                                    <h5>Moonshots (30%)</h5>
                                    <p>innovators with explosive potential.</p>
                                     <img src='\assets\threecoin.svg' className='imgonne'/>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
        </>
    )
}

export default Balanced
